export default function formatDate(date) {
    return (new Date(date + "Z").toLocaleDateString() + " " + new Date(date + "Z").toLocaleTimeString());
}

export  function formatDateWithoutHours(date) {
    return (new Date(date).toLocaleDateString());
}